import { ActionsUnion, createAction } from "store/helper";

import {
  IFinishWelcomeTutorialPayload,
  IInvitedAgent,
  IPartialInvitePayload,
  ISetCompanyNamePayload,
} from "./interfaces";

export const WelcomeTutorialViewActionsNames = {
  FINISH: "VIEWS/WELCOME_TUTORIAL/FINISH",
  CHECK_DOMAIN_AVAILABILITY: "VIEWS/WELCOME_TUTORIAL/CHECK_DOMAIN_AVAILABILITY",
  SET_COMPANY_NAME: "VIEWS/WELCOME_TUTORIAL/SET_COMPANY_NAME",
  INVITE_AGENTS: "VIEWS/WELCOME_TUTORIAL/INVITE_AGENTS",
  MAILBOX_COPIED: "VIEWS/WELCOME_TUTORIAL/MAILBOX_COPIED",
  SEND_FORWARDING_INSTRUCTIONS: "VIEWS/WELCOME_TUTORIAL/SEND_FORWARDING_INSTRUCTIONS",
  INVITE_AGENTS_PARTIAL_SUCCESS: "VIEWS/WELCOME_TUTORIAL/INVITE_AGENTS_PARTIAL_SUCCESS",
  KEEP_TUTORIAL_OPENED: "VIEWS/WELCOME_TUTORIAL/KEEP_TUTORIAL_OPENED",
};

export const WelcomeTutorialViewActions = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  finish: (payload?: IFinishWelcomeTutorialPayload) => createAction(WelcomeTutorialViewActionsNames.FINISH, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setCompanyName: (payload: ISetCompanyNamePayload) =>
    createAction(WelcomeTutorialViewActionsNames.SET_COMPANY_NAME, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  inviteAgents: (agents: IInvitedAgent[]) => createAction(WelcomeTutorialViewActionsNames.INVITE_AGENTS, { agents }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  mailboxCopied: () => createAction(WelcomeTutorialViewActionsNames.MAILBOX_COPIED),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  sendForwardingInstructions: (recipientEmail: string) =>
    createAction(WelcomeTutorialViewActionsNames.SEND_FORWARDING_INSTRUCTIONS, { recipientEmail }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  inviteAgentsPartialSuccess: (payload: IPartialInvitePayload) =>
    createAction(WelcomeTutorialViewActionsNames.INVITE_AGENTS_PARTIAL_SUCCESS, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  keepTutorialOpened: (opened: boolean) => createAction(WelcomeTutorialViewActionsNames.KEEP_TUTORIAL_OPENED, opened),
};

export type WelcomeTutorialViewAction = ActionsUnion<typeof WelcomeTutorialViewActions>;
